export const CART_STORAGE_KEY = "alharamaincab_cart";
export const CART_UPDATED_EVENT = "alharamaincab_cart_updated";

export interface CartItem {
  id: string;
  package_id: string;
  name: string;
  image: string;
  price: number;
  pickup_location: string;
  drop_location: string;
  vehicle_type?: string;
  passenger_capacity?: string;
  luggage_capacity?: string;
  baby_seat?: boolean | string;
}

const normalizePrice = (value: unknown) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
};

export const packageToCartItem = (item: any): CartItem => ({
  id: item?.id,
  package_id: item?.id,
  name: item?.vehicle_detail?.name || "Al-HaramainCab Ride",
  image: item?.image || "",
  price: normalizePrice(item?.price || item?.vehicle_detail?.price),
  pickup_location: item?.pickup_location?.name || "",
  drop_location: item?.drop_location?.name || "",
  vehicle_type: item?.vehicle_detail?.vehicle_type?.name,
  passenger_capacity: item?.vehicle_detail?.passenger_capacity,
  luggage_capacity: item?.vehicle_detail?.luggage_capacity,
  baby_seat: item?.vehicle_detail?.baby_seat
});

export const getCartItems = (): CartItem[] => {
  if (typeof window === "undefined") {
    return [];
  }

  try {
    const rawCart = window.localStorage.getItem(CART_STORAGE_KEY);
    const parsedCart = rawCart ? JSON.parse(rawCart) : [];
    return Array.isArray(parsedCart) ? parsedCart : [];
  } catch {
    return [];
  }
};

export const saveCartItems = (items: CartItem[]) => {
  window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent(CART_UPDATED_EVENT));
};

export const addCartItem = (item: CartItem) => {
  const items = getCartItems();
  const nextItems = items.some(cartItem => cartItem.package_id === item.package_id)
    ? items
    : [...items, item];

  saveCartItems(nextItems);
  return nextItems;
};

export const removeCartItem = (packageId: string) => {
  const nextItems = getCartItems().filter(item => item.package_id !== packageId);
  saveCartItems(nextItems);
  return nextItems;
};

export const clearCart = () => saveCartItems([]);

export const getCartTotal = (items: CartItem[]) =>
  items.reduce((total, item) => total + normalizePrice(item.price), 0);
